import React, { useState, useEffect } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { compose, prop } from 'js/utils/ramda.util';
import { Loader } from 'js/components/common/Loader';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentConfig } from 'js/hooks/component/useComponentConfig';
import { useComponentMethods } from 'js/hooks/component/useComponentMethods';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { Line } from './components/Line';
import { Table } from './components/Table';
import { TOP_WINNERS, VIEW } from './constants';
import { Carousel } from './components/Carousel';
import { withDynamicReducer, useDynamicReducerSelector } from './store';

import * as style from './TopWinners.scss';

export const TopWinnersBare = () => {
    let content = null;
    const translate = useComponentTranslations();
    const { view = VIEW.TABLE } = useComponentConfig();
    const { showComponentError } = useComponentMethods();
    const isGamesLoaded = useAppSelector(prop('isGamesLoaded'));
    const isLoading = useDynamicReducerSelector(prop('isLoading'));
    const [error, setError] = useState('');
    const topWinners = hooks.useTopWinners();

    hooks.useFetchComponent({ setError });

    useEffect(() => {
        if (error) {
            showComponentError(error);
        }
    }, [error, showComponentError]);

    if (isLoading || !isGamesLoaded) {
        return (
            <div className={`${style.wrapper} ${style.loader}`}>
                <Loader />
            </div>
        );
    }

    switch (view) {
        case VIEW.CAROUSEL:
            content = <Carousel />; break;
        case VIEW.TABLE:
            content = <Table />; break;
        case VIEW.LINE:
            content = <Line />; break;
        default: break;
    }

    return (
        <div className={`${style.wrapper} ${style[`${view}View`]}`}>
            {topWinners.length
                ? content
                : <span>{translate('noWinners')}</span>
            }
        </div>
    );
};

export const TopWinners = compose(
    withComponent({
        tkPrefix: 'playtech.mobile.system.top-winners.'
    }),
    withDynamicReducer()
)(TopWinnersBare);

componentService.registerPageComponents({ [TOP_WINNERS]: TopWinners });
componentService.registerWebContentComponents({ TopWinners });
